// Created: 2026-10-20 by header-alerts-glass (Claude)
// THE liquid-glass surface for selection/option lists in odv-truest (dropdowns, popovers,
// select menus, the Books tag menu). Doug 2026-10-20: "possibly apply our liquid glass concept
// for selections options lists". One definition: change it here, every option list follows.
//
// Concept source: gseat-pro/components/events/liquidGlass.js (frosted slate, top sheen,
// hairline border). Web translation: translucent near-black + backdrop blur + 1px top highlight.
//
// Contrast rule: the fill is 80% near-black over an already-dark shell, so gray-100 text stays
// >= 12:1 even over the brightest content behind it. Never lower the fill alpha below 0.7.
// If a browser lacks backdrop-filter the fill alone is still opaque enough to read.
// Brand gold #aea36d marks the selected row only; it is never a body-text color on glass.

export const GLASS_SURFACE =
  'rounded-xl border border-white/10 bg-gray-950/80 text-gray-100 ' +
  'backdrop-blur-xl backdrop-saturate-150 ' +
  'shadow-[0_12px_40px_rgba(0,0,0,0.55),inset_0_1px_0_rgba(255,255,255,0.10)]';

/** A row inside a glass list. Pair with `GLASS_ITEM_SELECTED` for the current value. */
export const GLASS_ITEM =
  'rounded-lg text-gray-200 transition-colors hover:bg-white/10 focus:bg-white/10 focus:outline-none';

export const GLASS_ITEM_SELECTED = 'text-[#aea36d] bg-[#aea36d]/10';

/** Search/filter input that sits on glass. */
export const GLASS_INPUT =
  'bg-white/5 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-[#aea36d]/40';
